import { CellphoneIcon } from './CellphoneIcon';

/**
 * author: Google
 * id 8898488F-1BE6-40A0-84B7-1C0832AA4754
 * name cellphone
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const StayCurrentPortraitIcon = CellphoneIcon;
export default StayCurrentPortraitIcon